import React from "react";
import "./DocAction.css";

/* Icon + label used for Create loading advice, Create invoice and Receipt. */
export function FlowDocAction({ icon, label, onClick, disabled = false, title, tone = "" }) {
  return (
    <button
      type="button"
      className={`flow-doc-action${tone ? ` is-${tone}` : ""}`}
      onClick={onClick}
      disabled={disabled}
      title={title || label}
    >
      <i className={`bi ${icon}`} aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}

export function FlowDocIcon({ icon, onClick, title }) {
  return (
    <button type="button" className="flow-doc-icon" onClick={onClick} title={title} aria-label={title}>
      <i className={`bi ${icon}`} aria-hidden="true" />
    </button>
  );
}
